export interface HeaderReader {
  get(name: string): string | null
}

/** Read the backend's stable machine-readable error key without using localized message text. */
export function readApiErrorKey(headers?: HeaderReader): string | undefined {
  return headers?.get('X-Error-Key')?.trim() || undefined
}

/** Only the stable backend concurrency key authorizes the destructive refresh/retry UX. */
export function isConcurrentUpdateError(error: unknown): boolean {
  return Boolean(
    error
    && typeof error === 'object'
    && 'errorKey' in error
    && error.errorKey === 'error.concurrent_update',
  )
}
